import type { Route } from '@angular/router';
import { locationCategoryRoutes } from './category/location-category.routes';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const locationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/location-list.component').then(
        ({ LocationListComponent }) => LocationListComponent,
      ),
    pathMatch: 'full',
  },
  // {
  //   path: 'additional-info/:id',
  //   loadComponent: () =>
  //     import('./additional-info/location-additional-info.component').then(
  //       ({ LocationAdditionalInfoComponent }) => LocationAdditionalInfoComponent,
  //     ),
  //   title: 'PAGES.LOCATION.BREADCRUMB.ADDITIONAL_INFO',
  //
  //   pathMatch: 'full',
  // },
  {
    path: 'category',
    children: locationCategoryRoutes,
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.LIST',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/location-details.component').then(
        ({ LocationDetailsComponent }) => LocationDetailsComponent,
      ),
    title: 'PAGES.LOCATION.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.LOCATION.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/location-details.component').then(
        ({ LocationDetailsComponent }) => LocationDetailsComponent,
      ),
    title: 'PAGES.LOCATION.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.LOCATION.SINGULAR'),
      ]),
    ],
  },
];
